import React from 'react';

import {ContainerRelevantItemsGraphQL} from 'relevant-items/containers/__generated/ContainerRelevantItemsGraphQL';
import {getContainerRelevantItemRowData} from 'relevant-items/getContainerRelevantItemsRowData';
import RelevantItemsTable from 'relevant-items/shared/RelevantItemsTable';

import {
  ContainerRelevantItemsFilteredTableState,
  UpdateContainerRelevantItemsFilteredTableState,
} from './ContainerRelevantItemsFilteredTableState';

export interface ContainerRelevantItemsSectionTableProps {
  relevantItemsGraphQL: ContainerRelevantItemsGraphQL;
  filteredTableState: ContainerRelevantItemsFilteredTableState;
  updateFilteredTableState: UpdateContainerRelevantItemsFilteredTableState;
  containerId: string;
  /** @default false */
  isCompact?: boolean;
  /** @default 100 */
  paginationLimit?: number;
}

// Table part of the container relevant items section.
export default function ContainerRelevantItemsSectionTable({
  relevantItemsGraphQL,
  filteredTableState,
  updateFilteredTableState,
  containerId,
  isCompact,
  paginationLimit,
}: ContainerRelevantItemsSectionTableProps): JSX.Element {
  const rowData = getContainerRelevantItemRowData(filteredTableState.filterOption, relevantItemsGraphQL);

  return (
    <RelevantItemsTable
      rowData={rowData}
      searchQuery={filteredTableState.searchQuery}
      pageOffset={filteredTableState.pageOffset}
      setPageOffset={(pageOffset) => {
        updateFilteredTableState({pageOffset});
      }}
      sortStateId={containerId}
      isCompact={isCompact}
      paginationLimit={paginationLimit}
    />
  );
}
